import React from "react";
import silverImg from "../../images/captain-tc/silver.png";

const CaptainTCSilverCardsContent = () => {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif", color: "#333", lineHeight: "1.6" }}>
      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <img 
          src={silverImg} 
          alt="Captain TC Silver Rewards Card" 
          style={{ maxWidth: "300px", height: "auto", display: "inline-block" }} 
        />
      </div>

      <h2 style={{ textAlign: "center", color: "#696969", fontSize: "28px", fontWeight: "bold", margin: "0 0 15px 0" }}>
        Captain TC Silver Rewards Card
      </h2>
      
      <h3 style={{ textAlign: "center", color: "#696969", fontSize: "22px", fontWeight: "bold", margin: "0 0 25px 0" }}>
        Exclusive Rewards
      </h3>

      <div style={{ textAlign: "center", marginBottom: "30px", fontSize: "16px", color: "#CCCEEF" }}>
        <p style={{ margin: "0 0 15px 0" }}>
          Receive a <strong>FREE Captain TC Silver Rewards Card</strong> with a qualifying purchase from a participating company on the Topcoin UK platform.
        </p>
        <p style={{ margin: "0" }}>
          These rewards are available exclusively with the Captain TC Silver Rewards Card.
        </p>
      </div>

      <ol style={{ paddingLeft: "20px", marginBottom: "30px", fontSize: "16px", color: "#CCCEEF" }}>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>Reward Topcoin</strong> - For every standard Topcoin you receive in your original Topcoin Wallet, you'll receive the same number of Reward Topcoin in your Captain TC Rewards Wallet. <strong>Bonus Topcoin are excluded.</strong>
        </li>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>£50 Rewards</strong> - Receive £2.50 for every 250 Reward Topcoin. Earn this 20 times: <strong>5,000 Reward Topcoin = £50.</strong>
        </li>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>Captain TC Gold Card Access</strong> - Your Captain TC Silver Rewards Card gives you access to collect Captain TC Gold Cards on qualifying product purchases from participating companies on the Topcoin UK platform. Collect <strong>20 Captain TC Gold Cards</strong> and receive a <strong>£16 reward</strong>.
        </li>
        <li style={{ marginBottom: "15px", paddingLeft: "10px" }}>
          <strong>5,000 Reward Topcoin Per Card</strong> - Each card is valid for up to 5,000 Reward Topcoin. Once you reach 5,000, your card is complete and you can receive a new card to continue earning rewards.
        </li>
      </ol>

      <div style={{ 
        border: "1px solid #A9A9A9", 
        backgroundColor: "#F5F5F5", 
        padding: "20px", 
        color: "#696969",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center"
      }}>
        One Card at a Time - You can have only one active Captain TC Rewards Card at a time - Bronze, Silver or Gold. Reach 5,000 Reward Topcoin to complete your current card before receiving a new one.
      </div>
    </div>
  );
};

export default CaptainTCSilverCardsContent;
